export const zh_TW = {
  shared_components: {
    common: {
      back: "返回",
      confirm_cancel: "確定取消？",
      current_executor: "當前執行者：",
      filter: "篩選條件",
      inspector: "巡查人",
      load_more: "上拉載入更多...",
      no: "否",
      organization_structure: "組織架構",
      please_enter: "請輸入",
      please_select: "請選擇",
      reject: "駁回",
      required_mark: " *",
      responsible_person: "負責人",
      status: "狀態",
      submit_date_end: "提交時間（止）",
      submit_date_start: "提交時間（起）",
      yes: "是",
      cancel: "取消",
      confirm: "確認",
      no_data: "暫無數據",
      delete: "刪除",
      save: "保存",
      submit: "提交",
      map_point: "平面圖標記",
      view_floor_plan: "查看平面圖",
      can_multi_select: "可多選",
      choose_take_photo_msg: "拍照",
      project_cost_center_code: "負責單位",
      project_name: "組織架構",
      choose: "選擇",
      get_data_failed: "獲取資料失敗！",
      go_back_key_img: "返回",
      please_select_last_finding_category: "請選擇最低層級的缺失/發現分類。",
      floor_plan: "平面圖"
    },
    add_inspection_object: {
      inspection_obj_add: "添加巡查物件",
      inspection_obj_input: "請輸入巡查物件",
      inspect_object_key: "巡查物件",
      add_must: "請至少新增一個巡查物件",
      other: "其他"
    },
    corp_select: {
      please_select_last_location_for_inspection: "請選擇最低層級的檢查地點"
    },
    filter_modals: {
      capa_code: "CAPA編號",
      capa_exec_date: "審核/接收日期",
      capa_final_verifier: "CAPA關閉最終驗證人",
      capa_finding_desc: "發現項描述",
      capa_finding_evidence: "發現項證據",
      capa_finding_no: "發現項編號",
      capa_main_process: "所屬主過程",
      capa_person_in_charge: "改善負責人",
      capa_source: "CAPA來源",
      capa_subject_title: "CAPA主題",
      capa_sub_process: "所屬子過程",
      completion_date: "完工日期",
      corrective_finished: "是否完成改善",
      data_scope: "資料範圍",
      ehsq_number: "評估ID",
      end_time: "截止時間",
      end_time_not_lg_start_time: "結束時間不能小於開始時間",
      evaluation_method: "評估方式",
      following_field: "以下欄位資料會在任務表單儲存後才產生",
      from: "(起)",
      full_name: "姓名",
      hazard_type: "災害類型",
      help_center_doc_name: "文件名稱",
      immediate_check_category: "檢查分類",
      incident_informant: "通報人",
      inspection_level: "檢查層級",
      job_name: "工作名稱",
      locations: "地點",
      poba: "受傷部位",
      project_id: "項目ID",
      project_name: "項目名稱",
      rate: "評級",
      reporting_department: "填報部門",
      responsibility_zone: "責任區域",
      audit_reviewer: "審核人",
      start_time: "開始日期",
      start_time_not_lg_end_time: "開始時間不能大於結束時間",
      supplier_id: "承攬商ID",
      target_finished: "是否完成目標",
      task_code: "任務編號",
      to: "(止)",
      unsafe_behavior: "不安全行為",
      unsafe_condition: "不安全狀況",
      violation_item: "違反事項",
      work_id_id: "作業ID",
      work_name: "作業名稱",
      work_related: "工作相關",
      id_number: "身份證號",
      incident_involved_person: "事故當事人",
      incident_notifier_pro: "項目經理",
      incident_reporting: "事故上報",
      inspection_finding_category: "發現分類",
      inspection_form: "巡查表",
      no: "否",
      project_cost_center: "組織架構",
      project_name_bbs: "組織架構",
      reviewer: "評審人",
      service_type: "服務類型",
      submit_person: "上報人",
      verification_person: "驗證人",
      yes: "是",
      audit_type_display_key: "巡查類型",
      business_line: "業務線",
      cancel_button_key: "取消",
      check_table_table: "表格",
      contractor_company: "承攬商公司",
      contractor_personnel_id: "承攬商人員ID",
      corrective_action_title_key: "改善措施",
      due_date_end: "截止日期（止）",
      due_date_start: "截止日期（起）",
      end_date: "結束時間",
      incident_category: "事故類別",
      incident_location: "事故地點",
      incident_location_range: "地點範圍",
      incident_organization: "權責單位",
      inspection_date_end: "巡查時間（止）",
      inspection_date_start: "巡查時間（起）",
      observer: "觀察員",
      occupation: "職業/工種",
      org_operation: "大區",
      report_date_key: "上報日期",
      report_time: "上報時間",
      reset: "重置條件",
      schedule_name: "排程名稱",
      area: "區域",
      project: "項目",
      years: "年份",
      report_start_time: "開始時間",
      report_end_time: "結束時間",
      audit_type: "審核類型",
      search_view_task_no_key: "任務編號:",
      select_upper_org_structure: "必須先選擇上一層組織架構",
      start_date: "開始時間",
      task_type: "巡查類型",
      work_area: "被觀察區域",
      work_risk_level: "工作風險等級",
      working_area: "工作區域",
      select_current_executor: "選擇當前執行者",
      select_final_verifier: "選擇最終驗證人",
      select_person_in_charge: "選擇改善負責人",
      select_reporter: "選擇上報人",
      select_reviewer: "選擇審核人",
      select_verifier: "選擇驗證人",
      incident_schedule: "進度",
      task_name: "任務名稱",
      incident_subject: "事故主旨",
      accident_number: "事故編號",
      select_capa_source: "選擇CAPA來源",
      search_capa_source: "搜尋CAPA來源",
      select_factory: "選擇廠房",
      search_factory: "搜尋廠房",
      search_employee: "搜尋員工"
    },
    gmp_floor_plan_dialog: {
      no_area_selected: "暫未選擇區域",
      please_mark_one_point_on_floor_plan: "請在平面圖上標記一個點位",
      reset_zoom: "重置縮放",
      selected_areas: "已選擇的區域"
    },
    image_annotator_modal: {
      arrow: "↗ 箭頭",
      cancel: "取消",
      circle: "○ 圓",
      clear: "✕ 清除",
      pen: "✏ 筆",
      pinch_zoom: "🤏 雙指縮放",
      rect: "□ 框",
      save: "儲存標註",
      text_tool: "T 文字",
      title_arrow: "箭頭",
      title_circle: "圓形",
      title_pen: "畫筆",
      title_rect: "矩形",
      title_reset_zoom: "重置縮放",
      title_text: "文字",
      undo: "↩ 復原"
    },
    my_title: {
      homepage: "首頁",
      enterprise_wechat_exit_home_alert: "企業微信退出首頁"
    },
    no_source_img: {
      no_data: "暫無資料"
    },
    org_select_modal: {
      choose_organization_structure: "選擇組織架構"
    },
    popover_dialog: {
      save_local: "暫存在手機"
    },
    return_dialog: {
      close_case: "關閉",
      invalid: "無效"
    },
    select_picture: {
      choose_from_media_msg: "從相冊選擇",
      confirm_delete_msg: "確認刪除？",
      get_image_fail: "獲取圖片失敗"
    },
    select_picture_new: {
      attachement_download_fail: "附件下載失敗",
      be_uploading: "正在上傳",
      cancel_key: "取消",
      load_from_gallery: "從圖庫中加載",
      select_image_source: "選擇圖片來源",
      use_camera: "使用相機",
      use_file: "從檔案中載入",
      camera_access_denied: "相機權限被拒絕，請在系統設定中開啟",
      camera_not_found: "未發現裝置上的相機。"
    },
    spinner: {
      data_load_msg: "數據載入中，請稍候..."
    },
    svg: {
      top: "頂部"
    },
    turn_to_send: {
      mission_assign_success: "轉派成功",
      report_member: "調查組組員",
      select_mission_assignee_msg: "請選擇任務轉派人！",
      turn_to_send: "轉派",
      turn_to_send_to: "任務轉派給",
      project_cost_center_code: "項目成本中心代碼"
    },
    select_file: {
      unsupported_format_desktop_only: "該附件格式暫不支援，請至電腦端查看",
      format_not_supported: "此文件格式暫不支援線上檢視，請使用網頁端介面下載檢視。"
    },
    fabric_canvas: {
      please_select_first: "無選取物體，請先選取物體後再操作。",
      delete_current_instance_only: "移除失敗，您只能移除對應此地點的繪圖內容。"
    }
  }
};
